import styled from 'styled-components';

export const CenteredWrapper = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
`;

export const ValueMappingMissingValueRowContent = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(255px, 1fr));
	grid-template-rows: 1fr;
	justify-content: center;
	gap: 1rem;
	width: 100%;
	height: 70px;
	min-height: fit-content;
`;
